import React, { FC, useState, useEffect } from "react";
import { TableRowDropdown } from "../Common";
import { ClockFormat, ClockSettings as Model } from "../../store/OJEUStore/models";

export interface ClockSettingsProps {
    clockSettings: Model,
    saveClockSettings: (newClockSettings: Model) => void
}

export const ClockSettings: FC<ClockSettingsProps> = (props) => {
    const [clockSettings, setClockSettings] = useState(props.clockSettings);

    const save = () => props.saveClockSettings(clockSettings);
    useEffect(() => {
        setClockSettings(props.clockSettings);
    }, [props.clockSettings]);

    return (
        <table className="table table-sm mb-1">
            <tbody>
                <TableRowDropdown
                    name="Time Format"
                    currentValue={clockSettings.timeFormat}
                    originalValue={props.clockSettings.timeFormat}
                    type={ClockFormat}
                    onChange={newValue => setClockSettings({ ...clockSettings, timeFormat: newValue })}
                    onSave={save}/>
            </tbody>
        </table>
    );
};
